<template>
	<div class="more-edit">
		<div class="title" style="margin-bottom:54px">患者管理_批量编辑</div>
		<a-table
			:scroll="{x:1600}"
			class="hospital-table"
			size="middle"
			:rowKey="record => record.id"
			:pagination="false"
			:dataSource="data"
		>
			<a-table-column width="3%" :customRender="(text, record, index) => `${index + 1}`">
				<span class="table-th" style="display:block;width: 30px" slot="title">序号</span>
			</a-table-column>
			<a-table-column width="7%" data-index="patientName" key="patientName">
				<span class="hospital-required table-th" slot="title">患者姓名</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.patientName}">
						<a-input style="margin: -5px 0;width: 80px" v-model="record.patientName"/>
					</div>
				</template>
			</a-table-column>
			<a-table-column width="4%" data-index="sexName" key="sexName">
				<span class="table-th" slot="title">性别</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.sexName}">
						<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" placeholder="请选择"
						          style="width: 60px" v-model="record.sexName">
							<a-select-option value="男">男</a-select-option>
							<a-select-option value="女">女</a-select-option>
						</a-select>
					</div>
				</template>
			</a-table-column>
			<a-table-column width="7%" data-index="clinicalDbId" key="clinicalDbId">
				<span class="table-th" slot="title">数据库ID</span>
				<template slot-scope="text, record">
					<a-input style="margin: -5px 0;width: 80px" v-model="record.clinicalDbId"/>
				</template>
			</a-table-column>
			<a-table-column width="8%" data-index="ageBirthDay" key="ageBirthDay">
				<span class="hospital-required table-th" slot="title">出生日期</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.ageBirthDay}">
						<a-date-picker
							:getCalendarContainer="triggerNode => triggerNode.parentNode"
							style="width: 120px"
							v-model="record.ageBirthDay"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column data-index="patientCardNo" key="patientCardNo">
				<span class="table-th" slot="title">身份证号</span>
				<template slot-scope="text, record">
					<a-input @blur='valite(record.patientCardNo)' style="margin: -5px 0;width: 150px"
					         v-model="record.patientCardNo"/>
				</template>
			</a-table-column>
			<a-table-column width="15%" data-index="address2" key="address2">
				<span class="table-th" slot="title">籍贯</span>
				<template slot-scope="text, record, index">
					<area-city @watchCity='getCityData' :areaRecord='record' :recordIndex='index'></area-city>
					<!-- <div @click="clkDispiker(record)">
					  <v-distpicker   @selected="onSelected(data,record,index)" province="140000" @city="onChangeCity" @area="onChangeArea" :province="record.province" :city="record.city" :area="record.country"></v-distpicker>
				  </div> -->
				</template>
			</a-table-column>
			<a-table-column width="7%" data-index="diseaseType" key="diseaseType">
				<span class="hospital-required table-th" slot="title">疾病类型</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.status&&!record.diseaseType}">
						<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" placeholder="请选择"
						          style="width: 100px" v-model="record.diseaseType">
							<a-select-option value="ALL">ALL</a-select-option>
							<a-select-option value="AML">AML</a-select-option>
						</a-select>
					</div>
				</template>
			</a-table-column>
			<a-table-column data-index="fatherName" key="fatherName">
				<span class="table-th" slot="title">父亲姓名</span>
				<template slot-scope="text, record">
					<a-input style="margin: -5px 0;width: 100px" v-model="record.fatherName"/>
				</template>
			</a-table-column>
			<a-table-column data-index="fatherPhone" key="fatherPhone">
				<span class="table-th" slot="title">父亲手机号</span>
				<template slot-scope="text, record">
					<a-input style="margin: -5px 0;width: 100px" v-model="record.fatherPhone"/>
				</template>
			</a-table-column>
			<a-table-column data-index="motherName" key="motherName">
				<span class="table-th" slot="title">母亲姓名</span>
				<template slot-scope="text, record">
					<a-input style="margin: -5px 0;width: 100px" v-model="record.motherName"/>
				</template>
			</a-table-column>
			<a-table-column data-index="motherPhone" key="motherPhone">
				<span class="table-th" slot="title">母亲手机号</span>
				<template slot-scope="text, record">
					<a-input style="margin: -5px 0;width: 100px" v-model="record.motherPhone"/>
				</template>
			</a-table-column>
		</a-table>
		<div class="footer">
			<a-button :loading="isHttpSubmit" @click="submitData" style="width:680px" type="primary">确认</a-button>
		</div>
	</div>
</template>

<script>
  import moment from "moment";
  import AreaCity from '../../components/common/city'
  import {regAll} from "../../common/validate";

  export default {
    props: {
      dataList: {type: Array, default: []}
    },
    components: {
      AreaCity
    },
    data() {
      return {
        data: [],
        formDatas: [],
        applyItems: [],
        sampleTypes: [],
        isSubmit: false,
        status: false,
        isHttpSubmit: false,
        isDispiker: false
      };
    },
    filters: {
      formTime(value) {
        return moment(value, "YYYY-MM-DD");
      }
    },
    created() {
      let newData = this.dataList.map(item => {
        if (item.ageBirthDay) {
          item.ageBirthDay = moment(item.ageBirthDay, "YYYY-MM-DD");
          return item;
        } else {
          return item;
        }
      });
      this.data = newData;
    },
    methods: {
      isCard(value) {
        if (value) {
          if (!regAll.regCardNo.test(value)) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      valite(value) {
        if (!this.isCard(value)) {
          this.$message.error('请输入正确的身份证号')
        }
      },
      clkDispiker() {
        this.isDispiker = true
      },
      getCityData(data) {
        let index = data.index
        let value = data.valueData
        this.data[index].province = value[0]
        this.data[index].city = value[1]
        this.data[index].country = value[2]
      },
      onSelected(data, record, index) {
      },
      onChangeProvince(a) {


      },

      onChangeCity(a) {


      },

      onChangeArea(a) {


        // this.show=false

      },
      checkRowData(data) {
        this.formDatas = [];
        this.data.forEach(item => {
          item.status = false;
          var status = true;
          if (item.patientName != null || item.patientName != "") {
            status = false;
          }
          if (
            (item.sexName != null || item.sexName != undefined) ||
            (item.ageBirthDay != null || item.ageBirthDay != undefined)
            (item.diseaseType != null || item.diseaseType != undefined)
          ) {
            status = false;
          }
          if (!status) {
            item.status = true;
            var formObj = {};
            for (let keyName in item) {
              if (keyName != "rowId" && keyName != "status") {
                formObj[keyName] = item[keyName];
              }
            }
            this.formDatas.push(formObj);
          }

        });
      },
      submitData() {
        let _this = this;
        this.isSubmit = true;
        this.checkRowData(this.data);
        let data = {};
        this.formDatas.map(item => {
          let tag = item.ageBirthDay.format("YYYY-MM-DD")
          item.ageBirthDay = tag
        })
        data.datas = JSON.parse(JSON.stringify(this.formDatas));

        this.$nextTick(() => {
          var errList = document.querySelectorAll(".has-error");
          if (errList.length == 0) {
            this.$put("/patient/batchUpdatePatient", data, {
              headers: {
                "Content-Type": "application/json;charset:utf-8"
              }
            }).then(res => {
              if (res.status == 200) {
                _this.$emit('getData')
                this.$message.success(res.data.message);
                _this.$emit("close");
              }
            });
          }
        });
      }
    }
  };
</script>
<style>
	.more-edit .distpicker-address-wrapper {
		width: 260px;
	}

	.more-edit .distpicker-address-wrapper select {
		height: 32px;
		width: 80px;
		font-size: 12px
	}
</style>
<style lang="scss" scoped>
	.more-edit {
		/deep/ .ant-table-body {
			min-height: 500px;
		}
		.title {
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
			padding-top: 82px;
		}

		.handle-header {
			background: rgba(249, 251, 251, 1);
			border: 1px solid rgba(240, 242, 245, 1);
			padding: 0 20px;
			line-height: 56px;
			margin-top: 40px;
			height: 56px;
			width: 100%;
			margin-bottom: 30px;
			.handle-name {
				float: left;
				font-size: 26px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);
			}
			.handle-select {
				float: left;
				margin-left: 180px;
			}
			/deep/ .handle-select-object {
				width: 160px;
				position: relative;
				height: 37px;
				display: inline-block;
				.ant-select {
					position: absolute;
					width: 100%;
					top: 12px;
				}
			}
			.handle-select-name {
				font-size: 26px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);
			}
		}
		.footer {
			padding: 40px 0;
			text-align: center;
		}
	}
</style>